<template>
  <v-form @submit.prevent="submit">
      <v-container class="mt-2">
          <v-row  justify="center" align="center">
            <StatusMessage :successmsg="success_msg" :errormsg="error_msg" style="width: 500px;" @close="clearMessages"></StatusMessage>
          </v-row>
          <v-row justify="center" align="center">
            <v-card class="white--text" color="rgb(13, 71, 161)" width="500" dark>
                <v-card-title class="pt-8 white--text justify-center">
                  Login
                </v-card-title>
                <v-card-text>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.email"
                      :error-messages="errors.email"
                      label="E-mail"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.password"
                      type="password"
                      label="Password"
                      :error-messages="errors.password"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                    class="text-center"
                  >
                  </v-col>
                </v-card-text>
                <v-card-actions class="justify-space-between my-4">
                  <v-btn text @click="toForgotPassword">Forgot Password?</v-btn>
                  <v-btn rounded class="primary" type="submit" :disabled="loading">Sign In</v-btn>
                </v-card-actions>
                <LoadingOverlay :loading="loading"></LoadingOverlay>
            </v-card>
          </v-row>
      </v-container>
  </v-form>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import StatusMessage from "@/components/utils/StatusMessage"
  import LoadingOverlay from "@/components/utils/LoadingOverlay"

  export default {
    name: 'SignIn',
    components: {
      StatusMessage,
      LoadingOverlay
    },
    data () {
      return {
        form: {
          email: '',
          password: '',
        },
      }
    },
    computed: {
      ...mapGetters({
        authUser: 'auth/authUser',
        errors: 'auth/errors',
        error_msg: 'auth/error_msg',
        success_msg: 'auth/success_msg',
        loading: 'auth/loading',
        isReadOnly: 'auth/isReadOnly'
      })
    },
    methods: {
      ...mapActions({
        login: 'auth/login'
      }),
      ...mapMutations({
        clearMessages: 'auth/RESET_MSGS',
      }),
      async submit () {
        await this.login(this.form)
        if(this.authUser) {
          if(this.isReadOnly)
            this.$router.replace({ name: 'SearchCases' })
          else
            this.$router.replace({ name: 'PendingCases' })
        }
      },
      toForgotPassword() {
        this.clearMessages()
        this.$router.push({name: 'ForgotPassword'})
      }
    },
  }
</script>